import { VALID_WHISHLIST_DOMAINS } from 'utils/consts';


type WishListValue = {
  url: string;
  valid: boolean;
};

type WishListItem = {
  wishListAmazon: WishListValue;
  wishListEden: WishListValue;
  wishListStockroom: WishListValue;
  wishListSwagStore: WishListValue;
};

export function wishListDomain(wishList: WishListItem, index: number): string | Array<string> {
  if (Object.keys(wishList).length === 4) {
    const currentDomain = VALID_WHISHLIST_DOMAINS[index];

    if (index === 2) {
      return [
        `www.${currentDomain[0]}.`,
        `www.${currentDomain[1]}.`,
      ];
    }

    return `www.${currentDomain}.`;
  }

  const currentDomain = VALID_WHISHLIST_DOMAINS[index + 1];
  if (index === 1) {
    return [
      `www.${currentDomain[0]}.`,
      `www.${currentDomain[1]}.`,
    ];
  }

  return `www.${currentDomain}.`;
}

export function checkProtocolWishListUrl(url: string): string {
  if (url.includes('http://') || url.includes('https://')) {
    return url;
  }

  return `https://${url}`;
}

export function checkNetworkWishListUrl(url: string): string {
  if (!url.includes('www')) {
    return url.replace('//', '//www.');
  }

  return url;
}
